import React from 'react';
import { Link } from 'react-router-dom';
import NoteCard from '../components/NoteCard';
import { NOTES } from '../data/notes';
import { useReveal } from '../hooks/useReveal';

function NotesPage() {
  useReveal();

  return (
    <div className="page page--notes">
      <div className="container">
        <header className="page__header reveal">
          <Link to="/" className="page__back">
            &larr; Back home
          </Link>
          <h1 className="page__title">My Observations</h1>
          <p className="page__subtitle">
            A running list of some of my recent thoughts and musings. Proceed
            with caution, my brain can be a wild place.
          </p>
        </header>

        <div className="notes-page__grid reveal reveal--delay-1">
          {NOTES.map((note) => (
            <NoteCard key={note.slug} note={note} variant="notes-page" />
          ))}
        </div>
      </div>
    </div>
  );
}

export default NotesPage;
